import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig } from '../config.js';
import sr from '../utils/sr';
import { usePrefersReducedMotion } from '../hooks';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


const StyledProjectsSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;

  .head{
    margin-bottom: 34px;
    color: #ccd6f6;
    font-size: 23px;
    font-weight: 650;
  }
  .num{
    margin-bottom: 34px;
    margin-right:15px;
    color: #64ffda;
    font-size: 19px;
    font-weight: 500;
    margin-left: 40px;
  }

  .bor{
    margin-left:40px;
    border-color:#233554;
  }
  .card{
    background-color: #112240;
    border-radius: 10px;
    height: 190px;
    max-width: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 50px;
    flex: 1 0 21%; /* explanation below */
    margin: 20px;
  }

  svg{
    height: 100px;
    width: 89px;
    color: #64ffda;
    fill: #64ffda;
  }

  .name{
    display: flex;
    justify-content: center;
    color:#ccd6f6
  }

  .cards{
    display: flex;
    flex-wrap: wrap;
    max-width: 1000px;
    margin-top: 50px;
  }
`;
const StyledJobCard = styled.section`
  .App {
  font-family: sans-serif;
  text-align: center;
}
.collapsible-card {
  margin: 30px;
  border-radius: 8px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2);
  padding: 0px 15px;
  overflow: hidden;
  height: 300px;
  width: 300px;
}
.header {
  height: 40px;
  width: 100%;
  cursor: grab;
}
.content {
  transition: height 0.4s ease;
  padding: 0px 20px;
  overflow: hidden;
}

img{
  width: 200px;
  height: 200px;
  scale: 1;
}

.job{
    background-color: #112240;
    border-radius: 7px;
    max-height: 600px;
    max-width: 510px;
    margin: 20px;
    width: 500px;
  }
  .expand{
    size: 10px;
  }

  h2{
    font-size:22px;
    font-weight: 500;
  }
  h3{
    font-size:15px;
    font-weight: 350;
  }
  .text-green{
    font-size: 16px;
  }
  p{
    color: #ccd6f6,
  }
  a{
    font-size: 20px;
    color: #64ffda;
    margin-top: 10px;
  }
`;

 const ExpandMore =  styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  
}));

const styleforButton = {
  width: '40px',
  height: '10vh',
  float: 'right',
  textAlign: 'right',
}

const Experience = () => {

  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
 

  return (
    <StyledProjectsSection id="expi" ref={revealContainer}>

    <h2 className="numbered-heading ">Work Experience</h2>
   
    <div className='jobs'>
    <StyledJobCard>
      <Card sx={{ maxWidth: 400 }} className='job'>
        <CardMedia
          component="img"
          height="194"
          image="https://elenageosystems.com/static/media/logo-250.bec1e086.png"
          alt="Paella dish"
        />
    
        <CardActions disableSpacing>
          <Typography className='header'>
            <h2 className='company' >Elena Geo Systems <br /></h2>
            <h3 ><span className='text-green'>Software Intern</span>/October'23-January'24<br /></h3>
      
          </Typography>
          <ExpandMore 
            className='expand'
            expand={expanded}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
            orientation="right"
          >
            <ExpandMoreIcon style={styleforButton} />
          </ExpandMore>
        </CardActions>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <p className='text-lightestslate'>
            Worked on developing a NaVIC based Bus-Tracking system that would provide an real time data of the bus location to the passengers.
            Also, the drive details and vehicle health can be monitored by the admin.
            A history of the bus route and the time taken can be viewed by the admin.
            This project was dropped off midway due to some internal issues.
            </p>

            <a href="https://github.com/electro-coder/NavIC-Institute-Bus-Tracking-System">Project Link</a>
          </CardContent>
        </Collapse>
      </Card>
      
    </StyledJobCard>
      

    </div>


    

    </StyledProjectsSection>
  );
};

export default Experience;
